"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _sharedVariables = require("../../shared-variables");
require("./cross-fade.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * `CrossFade` provides crossfading animation from the previous child to the new child
 * received by the component. Each child must have a unique childKey. CrossFade handles positioning
 * and stacking the children appropriately.
 */
var CrossFade = function CrossFade(_ref) {
  var children = _ref.children,
    childKey = _ref.childKey;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-relative flex-auto"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    component: null
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "sb-crossFade",
    key: childKey,
    timeout: {
      enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
      exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
    }
  }, children)));
};
CrossFade.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  /**
   * A unique string to be used like a React `key` on the current child.
   * As one child is being removed and a new one added, the unique key
   * per child helps the underlying React Transition Group animate the old child out
   * while the new one is animating in.
   */
  childKey: _propTypes["default"].string.isRequired
} : {};
CrossFade.displayName = 'CrossFade';
var _default = exports["default"] = CrossFade;